import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-0 md:pt-28 overflow-hidden" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-32">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(212,175,55,0.12) 0%, transparent 70%)'
    }} data-id="element-33" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center pl-[3px] pr-[3px] mt-[-35px] mb-[-35px]" data-id="element-34">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-5 py-2 rounded-full bg-neutral-900 border border-[#D4AF37]/30 text-[#D4AF37] text-sm font-bold tracking-wider pt-[1px] pb-[1px] mt-[8px] mb-[8px]" data-id="element-35">
          <span className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" data-id="element-36" />
          KIT MÁQUINA DE VENTAS™
        </div>

        {/* Headline */}
        <h1 className="animate-fade-in-up delay-100 text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-[1.08] tracking-tight mb-6" data-id="element-37">
          Todo para que tu negocio digital funcione YA
        </h1>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-150 flex justify-center mb-8" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/wpW8cRDygq21z57X1vVeYe/d42fcce7-4431-4a74-94c6-489388bf718d.png" alt="Kit Máquina de Ventas — Protocolo Digital 2025" className="w-full max-w-md md:max-w-xl drop-shadow-[0_25px_45px_rgba(212,175,55,0.18)] mt-[-25px] mb-[-25px]" data-id="element-39" />
        </div>

        {/* Product Card */}
        <div className="animate-fade-in-up delay-200 bg-neutral-900/80 border border-[#D4AF37]/30 rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden pt-[3px] pb-[3px]" data-id="element-40">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#B8941F] via-[#E5C158] to-[#B8941F]" data-id="element-41" />
          <h2 className="text-xl md:text-3xl text-white mb-3 font-[800]" data-id="element-42">
            KIT MÁQUINA DE VENTAS™ — PROTOCOLO DIGITAL 2025
          </h2>
          <p className="md:text-lg text-[#E5C158] mb-4 text-[14px] font-[900]" data-id="element-43">
            El sistema N°1 para emprendedores digitales en Argentina - Nicho +
            Oferta + Embudo + Tráfico + Automatización + Escalado
          </p>
          <p className="text-gray-300 md:text-lg max-w-3xl mx-auto text-[14px]" data-id="element-44">
            Anuncios + copy + ventas + sistema técnico + finanzas listos para
            implementar. Sin perder más tiempo aprendiendo sin resultados.
          </p>
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-300 flex flex-col items-center mb-6" data-id="element-45">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-lg md:text-xl font-bold text-black bg-gradient-to-b from-[#E5C158] to-[#D4AF37] hover:from-[#F0CF6E] hover:to-[#E5C158] rounded-xl transition-all active:scale-95 shadow-lg shadow-[#D4AF37]/20" data-id="element-46">
            → QUIERO MI KIT AHORA
          </a>
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-5 text-xs md:text-sm font-medium text-gray-500" data-id="element-47">
            <span data-id="element-48">🛡️ Garantía 30 días</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-49">|</span>
            <span data-id="element-50">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-51">|</span>
            <span data-id="element-52">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-400 flex flex-wrap md:gap-3 mt-[6px] mb-12 gap-[4px] flex-row items-start justify-center" data-id="element-53">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Contexto Argentina 2025', '📚 6 Tomos + 6 Guías', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-neutral-900/80 text-gray-200 text-xs md:text-sm font-medium border border-neutral-800 pt-[6px] pb-[6px]" data-id="element-54">
              {b}
            </span>)}
        </div>

        {/* Video Preview */}
        <div className="animate-fade-in-up delay-500 max-w-3xl mx-auto mb-16 rounded-2xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-900" data-id="element-55">
          <video src="https://cdn.magicpatterns.com/uploads/eWZFFYHyijVsNKGDwmZYR2/VIDEO%20MAGIC%20KIT%20MAQUINA%20DE%20VENTAS.mp4" autoPlay loop muted playsInline className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-56" />
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-neutral-800 bg-neutral-950/60" data-id="element-57">
        <div className="max-w-5xl mx-auto px-4" data-id="element-58">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 py-8 md:py-10" data-id="element-59">
            {[{
            val: '+300',
            label: 'emprendedores ya lo tienen'
          }, {
            val: '6',
            label: 'Tomos completos'
          }, {
            val: '6',
            label: 'Guías incluidas'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-4" data-id="element-60">
                <div className="text-2xl md:text-4xl font-bold text-[#D4AF37] mb-1" data-id="element-61">
                  {s.val}
                </div>
                <div className="text-[11px] md:text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-62">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}